module.exports = __webpack_public_path__ + "media/images/hero/glyph-4-6d08b0c761002100c5d9ca4e125e67a8.svg";